import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { CarouselImage } from 'components/image-carousel';
import { APIGeoCity, APIGeoBuilding, APIGeoDistrict, APIGeoStreet } from 'api/types';

export type APIBuildingRes = {
  id: number;
  title: string;
  images: string[];
  apartmentComplex: string;
  commissioningQuarter: string | null;
  geoCity: APIGeoCity | null;
  geoStreet: APIGeoStreet | null;
  geoBuilding: APIGeoBuilding | null;
  geoDistrict: APIGeoDistrict | null;
};

const useBuilding = (id: number) => {
  const { data, error, isLoading } = useSWR(
    id ? `/apartment-complexes/buildings/${id}` : null,
    (url) =>
      fetcher.swr<APIBuildingRes>(url).then((building) => {
        const { images: _images, ...rest } = building;
        const images: CarouselImage[] = _images.map((src) => ({
          src,
          alt: 'Изображение дома ' + building.title,
        }));

        return { ...rest, images };
      }),
    { errorRetryCount: 0, revalidateOnFocus: false },
  );

  return { building: data, error, isLoading };
};

export default useBuilding;
